import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RequireAcceptedTermsOfServicesGuard } from '@services/require-accepted-terms-of-services-guard.service';
import { RequireConfirmedContactMethodsGuard } from '@services/require-confirmed-contact-methods-guard.service';
import { VendorRoleGuard } from '@services/vendor-role-guard.service';
import { ThemeDetailsComponent } from '@theme/components/theme-details/theme-details.component';
import { ThemingDashboardComponent } from '@theme/components/theming-dashboard/theming-dashboard.component';
import { environment } from 'src/environments/environment';

const routes: Routes = [
  {
    path: 'theming',
    component: ThemingDashboardComponent,
    data: { breadcrumb: 'theming' },
    canActivate: [RequireAcceptedTermsOfServicesGuard],
    children: [
      {
        path: ':id',
        component: ThemeDetailsComponent,
        data: { breadcrumb: 'details' }
      }
    ]
  },
  {
    path: 'ilt',
    loadChildren: () => import('@ilt/instructor-led-training.module').then((m) => m.InstructorLedTrainingModule),
    data: { breadcrumb: 'ilt', selectOrgInstructor: true },
    canActivate: [RequireAcceptedTermsOfServicesGuard, RequireConfirmedContactMethodsGuard]
  },
  {
    path: 'learning',
    loadChildren: () => import('@learning/learning.module').then((m) => m.LearningModule),
    data: { breadcrumb: 'learning' },
    canActivate: [RequireAcceptedTermsOfServicesGuard, RequireConfirmedContactMethodsGuard]
  },
  {
    path: 'organizations',
    loadChildren: () => import('@organizations/organizations.module').then((m) => m.OrganizationsModule),
    data: { breadcrumb: 'organizations' },
    canActivate: [RequireAcceptedTermsOfServicesGuard, RequireConfirmedContactMethodsGuard]
  },
  {
    path: 'selling',
    loadChildren: () => import('@vendor/vendor.module').then((m) => m.VendorModule),
    data: { breadcrumb: 'vendor' },
    canActivate: [RequireAcceptedTermsOfServicesGuard, RequireConfirmedContactMethodsGuard, VendorRoleGuard]
  },
  {
    path: 'authoring',
    loadChildren: () => import('@author/author.module').then((m) => m.AuthorModule),
    data: { breadcrumb: 'authoring' },
    canActivate: [RequireAcceptedTermsOfServicesGuard, RequireConfirmedContactMethodsGuard]
  },
  {
    path: 'grading',
    loadChildren: () => import('@grader/grader.module').then((m) => m.GraderModule),
    data: { breadcrumb: 'grading' },
    canActivate: [RequireAcceptedTermsOfServicesGuard, RequireConfirmedContactMethodsGuard]
  },
  {
    path: 'training',
    loadChildren: () => import('@training-manager/training-manager.module').then((m) => m.TrainingManagerModule),
    data: { breadcrumb: 'training-manager', showShoppingCart: true },
    canActivate: [RequireAcceptedTermsOfServicesGuard, RequireConfirmedContactMethodsGuard]
  },
  {
    path: 'user',
    loadChildren: () => import('./user/user.module').then((m) => m.UserModule),
    data: { breadcrumb: 'user' },
    canActivate: [RequireAcceptedTermsOfServicesGuard]
  },
  {
    path: 'support',
    loadChildren: () => import('./support/support.module').then((m) => m.SupportModule),
    data: { breadcrumb: 'provide-support' },
    canActivate: [RequireAcceptedTermsOfServicesGuard, RequireConfirmedContactMethodsGuard]
  },
  {
    path: 'revenues',
    loadChildren: () => import('./revenues/revenues.module').then((m) => m.RevenuesModule),
    data: { breadcrumb: 'revenues' },
    canActivate: [RequireAcceptedTermsOfServicesGuard, RequireConfirmedContactMethodsGuard]
  },
  {
    path: '**',
    redirectTo: 'learning'
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      enableTracing: environment.verboseRoutes
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
